
      import Switch from './switch.vue'
      import type { App, Plugin } from 'vue'

      export const SwitchPlugin: Plugin = {
        install(app: App) {
          app.component('Switch', Switch)
        },
      }
      export { Switch }
      